export const FREE_SHIPPING_THRESHOLD = 1000

export const initialForm = {
  name: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  province: '',
  postalCode: '',
}

export const LOCKER_FEE_TIERS = [
  { maxKg: 2, fee: 49 },
  { maxKg: 5, fee: 59 },
  { maxKg: 10, fee: 69 },
  { maxKg: 15, fee: 89 },
  { maxKg: 20, fee: 119 },
]

export const DIRECT_FEE_TIERS = [
  { maxKg: 2, fee: 72.97 },
  { maxKg: 5, fee: 83.54 },
  { maxKg: 10, fee: 115.27 },
  { maxKg: 15, fee: 164.97 },
  { maxKg: 20, fee: 221.02 },
]

export { courierGuyLockers, provinces } from './lockers'
